// extracted by mini-css-extract-plugin
module.exports = {"preview":"PasswordConfirm_preview__Q3T3c"};